import { EditableText } from "core/components/editable-text";
import { ChangeEvent, ReactNode, useState } from "react";

interface IEditableDescriptionProps {
  onSubmit: (value: string) => Promise<any>;
  initialValue: string;
  children: ReactNode;
}

export function EditableDescription({
  onSubmit,
  initialValue,
  children,
}: IEditableDescriptionProps) {
  const [text, setText] = useState(initialValue);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setText(e.target.value);
  };

  const handleSubmit = async () => {
    await onSubmit(text);
  };

  return (
    <EditableText
      onPressEnter={handleSubmit}
      onChange={handleChange}
      onBlur={handleSubmit}
      value={text}
      autoFocus
    >
      {children}
    </EditableText>
  );
}
